import { ModelBase } from '../../core/models/model-base.model';

export class Course extends ModelBase {
  name: string;
  version: string;
  constructor(obj?: any) {
    super(obj);
    if (!obj) {
      return;
    }
    this.id = obj.id;
    this.code = obj.code;
    this.name = obj.name;
    this.version = obj.version;
  }
}
